@if (container) {
  <div class="details">
    <div class="details__column">
      @if (container.shipments.length === 1) {
        @if (container.parties.shipper) {
          <div class="details__column--label">Shipper</div>
          <span>{{ container.parties.shipper.name }}</span>
          @if (container.parties.shipper.country) {
            <div>{{ container.parties.shipper.country }}</div>
          }
        }
      } @else {
        <div class="details__column--label">Shipper</div>
        <span>MISCELLANEOUS</span>
      }
    </div>

    <div class="details__column">
      @if (container.parties.consignee) {
        <div class="details__column--label">Consignee</div>
        <span>{{ container.parties.consignee.name }}</span>
        @if (container.parties.consignee.country) {
          <div>{{ container.parties.consignee.country }}</div>
        }
      }
    </div>

    @if (container.goodsSummary) {
      <div class="details__column--full">
        <div class="details__column--label">Goods Summary</div>
        <div>
          @if (container.goodsSummary.totalPackages > 0) {
            <span class="details__column--value">{{ container.goodsSummary.totalPackages }} CLL</span>
          }

          @if (container.goodsSummary.totalWeightInKg > 0) {
            <span class="details__column--value">{{ container.goodsSummary.totalWeightInKg }} KG</span>
          }

          @if (container.goodsSummary.totalVolumeInCbm > 0) {
            <span class="details__column--value"
              >{{ container.goodsSummary.totalVolumeInCbm | number: '1.0-3' : 'de-DE' }} CBM</span
            >
          }
        </div>
      </div>
    }

    <div class="details__column">
      @if (container.shipmentType) {
        <div class="details__column--label">Shipment Type</div>
        <span>{{ container.shipmentType }}</span>
      }
    </div>

    <div class="details__column">
      @if (container.shipmentService) {
        <div class="details__column--label">Shipment Service</div>
        <span>{{ container.shipmentService }}</span>
      }
    </div>

    <div class="details__column--full">
      <div class="details__column--label">References</div>
      <span>{{ container.shipments | getAllReferences }}</span>
    </div>

    <div class="details__column">
      @if (container.shipments.length) {
        @switch (container.shipments[0].transportMode) {
          @case ('Ocean') {
            <ng-container *ngTemplateOutlet="hbl"></ng-container>
          }
          @case ('Rail') {
            <ng-container *ngTemplateOutlet="hbl"></ng-container>
          }
          @case ('Air') {
            <div class="details__column--label">HAWB</div>
            <div class="details__column--wrapped">
              @for (shipment of container.shipments; track shipment.shipmentNo) {
                @if (shipment.houseNo) {
                  <span>{{ shipment.houseNo }}</span>
                }
              }
            </div>
          }
          @case ('Courier') {
            <div class="details__column--label">Track and Trace</div>
            <div class="details__column--wrapped">
              @for (shipment of container.shipments; track shipment.shipmentNo) {
                @if (shipment.trackAndTrace) {
                  @if (isArchived) {
                    <a [href]="shipment.trackAndTrace" target="_blank">{{ shipment.trackingNo || 'Tracking Link' }}</a>
                  } @else {
                    <span>{{ shipment.trackingNo || 'Tracking Link' }}</span>
                  }
                } @else {
                  <span>--</span>
                }
              }
            </div>
          }
        }
        <ng-template #hbl>
          <div class="details__column--label">HBL</div>
          <div class="details__column--wrapped">
            @for (shipment of container.shipments; track shipment.shipmentNo) {
              @if (shipment.houseNo) {
                <span>{{ shipment.houseNo }}</span>
              }
            }
          </div>
        </ng-template>
      }
    </div>

    <div class="details__column--full">
      <div class="details__column--label">SGL Shipment No.</div>
      <div class="details__column--wrapped">
        @for (shipment of container.shipments; track shipment.shipmentNo) {
          @if (isArchived) {
            <span>{{ shipment.shipmentNo }}</span>
          } @else {
            <a routerLink="/overview/{{ shipment.shipmentNo }}">{{ shipment.shipmentNo }}</a>
          }
        }
      </div>
    </div>

    <div class="details__column">
      @if (container.containerNo) {
        <div class="details__column--label">Container no</div>
        <div class="details__column--value display-flex">
          <span class="pr-10">{{ container.containerNo }}</span>
          @if (!isArchived) {
            @if (windwardLinksLoading) {
              <span class="mat-spinner_loading">
                <mat-spinner diameter="16"></mat-spinner>
              </span>
            } @else {
              @if (!!customMapUrl) {
                <a class="live-tracking" (click)="openLiveTracking(container.containerNo)">Live Tracking</a>
              }
            }
          }
        </div>
      }
    </div>

    <div class="details__column">
      @if (container.containerType) {
        <div class="details__column--label">Container Type</div>
        <span>{{ container.containerType }}</span>
      }
    </div>
  </div>
} @else {
  <app-container-details-skeleton></app-container-details-skeleton>
}
